import React from 'react';
import { ShowIf } from 'components/utils';
import { Input } from 'components/tt-forms/common';

let MsetTimeout;

class InputListHasSuggestions extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      dataSuggest: this.props.dataSuggest,
      value: '',
      valueName: this.props.valueName,
      keyName: this.props.keyName,
      isSearch: this.props.isSearch,
      search: false,
      indexConfirm: ''
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.convertValueToData(nextProps.data)
    }
    this.setState({
      isSearch: nextProps.isSearch
    })

    if (nextProps.dataSuggest != this.props.dataSuggest) {
      this.setState({
        dataSuggest: nextProps.dataSuggest,
        search: true
      })
    }
  }

  componentDidMount() {
    this.convertValueToData(this.props.data);
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  handleConfirm(data) {
    if(this.props.handleConfirm(data)) {
      //do nothing
    } else {
      this.removeDonViConfirm();
    }
  }

  convertValueToData(data) {
    let dataResult = [];
    let newCheck = data;
    if (newCheck) {
      newCheck.map(state => {
        dataResult[dataResult.length] = {
          [this.state.keyName]: state[this.state.keyName],
          [this.state.valueName]: state[this.state.valueName]
        };
      });
      this.setState({
        data: [...dataResult]
      })
    } else {
      this.setState({
        data: []
      })
    }
  }

  convertDataToValue() {
    let e = {
      target: {
        value: [],
        count: this.state.data.length
      }
    }
    this.state.data.map(state => {
      e.target.value[e.target.value.length] = {
        id: state[this.state.keyName]
      }
    })
    this.props.onChange(e);
  }

  onChange(e) {
    clearTimeout(MsetTimeout)
    this.setState({
      value: e.target.value
    },() => {
      this.handleSuggest()
    })
  }

  handleSuggest() {
    MsetTimeout = setTimeout(() => {
      if (this.state.value) {
        document.addEventListener('click', this.handleOutsideClick.bind(this), false);
        this.props.handleSuggest(this.state.value);
      }
    }, 1000);
  }

  handleSearch(e) {
    clearTimeout(MsetTimeout)
    if (typeof e != 'undefined') {
      e.preventDefault();
    }
    if (this.state.value) {
      document.addEventListener('click', this.handleOutsideClick.bind(this), false);
      this.props.handleSuggest(this.state.value);
    }
    return;
  }

  addDonVi(index,e) {
    let newArr = [...this.state.data];
    let dataSuggest = [...this.state.dataSuggest];

    let itemSelected = dataSuggest[index];

    let arrCheck = newArr.filter(state => {
      return state[this.state.keyName] == itemSelected[this.state.keyName]
    })

    if (arrCheck.length > 0) {
    } else {
      let newItem = {
        [this.state.valueName]: itemSelected[this.state.valueName],
        [this.state.keyName]: itemSelected[this.state.keyName]
      }
      this.setState({
        data: [
          ...this.state.data,
          newItem
        ],
      }, () => {
        this.convertDataToValue()
      })
    }
    document.removeEventListener('click', this.handleOutsideClick.bind(this), false);
  }

  removeDonVi(index) {
    if(this.props.confirm) {
      this.setState({
        indexConfirm: index
      }, () => {
        this.handleConfirm(this.state.data[index]);
      })
    } else {
      let newData = [...this.state.data];
      newData.splice(index, 1);
      this.setState({
        data: newData
      }, () => {
        this.convertDataToValue()
      })
    }
  }

  removeDonViConfirm() {
    let newData = [...this.state.data];
    newData.splice(this.state.indexConfirm, 1);
    this.setState({
      data: newData
    }, () => {
      this.convertDataToValue()
    })
  }

  closeOption(){
    this.setState({
      value: '',
      dataSuggest: [],
      search: false
    })
    document.removeEventListener('click', this.handleOutsideClick.bind(this), false);
  }

  handleOutsideClick(e) {
    if (this.node && this.node.contains(e.target)) {
      return;
    } else if (this.node && !this.node.contains(e.target)){
      this.closeOption();
    }
  }

  render() {
    return (
      <form className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.handleSearch.bind(this)}>
        <div className='wrap-input-tt-dvph col-25' id='node' ref={node => { this.node = node; }}>
          <Input label={this.props.label} name={this.props.name} placeholder='Nhập...' className='col-100 no-gutter' value={this.state.value} onChange={this.onChange.bind(this)}/>
          <button className={this.props.isSearch ? 'btn-search-dvph searching' : 'btn-search-dvph'} name={this.props.name} type='submit'></button>
          <ShowIf condition={this.state.dataSuggest.length > 0}>
            <div className='wrap-suggestions'>
              {
                this.state.dataSuggest.map((item, i) => {
                  return(
                    <p key={i} className='suggestions-item' onClick={this.addDonVi.bind(this, i)}>{item[this.state.valueName]}</p>
                  )
                })
              }
            </div>
          </ShowIf>
          <ShowIf condition={this.state.dataSuggest.length == 0 && this.state.search == true}>
            <div className='wrap-suggestions'>
              <p className='suggestions-item'>Không có dữ liệu</p>
            </div>
          </ShowIf>
        </div>
        <ShowIf condition={!this.props.hasCount}>
          <div className='col-75 mb18'>
            <div className='ds-tt-dvph'>
              {
                this.state.data.map((item,i) => {
                  return (
                    <div className='tt-dvph-item' key={i}>
                      <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this,i)}>×</span>
                      <span className="tt-dvph-value">{item[this.state.valueName]}</span>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </ShowIf>
        <ShowIf condition={this.props.hasCount}>
          <div className='col-60 mb18'>
            <div className='ds-tt-dvph'>
              {
                this.state.data.map((item,i) => {
                  return (
                    <div className='tt-dvph-item' key={i}>
                      <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this,i)}>×</span>
                      <span className="tt-dvph-value">{item[this.state.valueName]}</span>
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className='col-15 mb18 count-dv'>
            Tổng: {this.state.data.length}&nbsp;{this.props.countUnit}
          </div>
        </ShowIf>
      </form>
    );
  }
}

InputListHasSuggestions.defaultProps = {
  data: '',
  label: 'This is label',
  hasCount: false,
  dataSuggest: [],
  countUnit: 'đơn vị',
  valueName: '',
  keyName: '',
  confirm: false,
  isSearch: false,
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  handleSuggest: function() {
    console.log('Need to assign handleSuggest method');
  }
}

export default InputListHasSuggestions ;


// WEBPACK FOOTER //
// ./src/components/tt-forms/common/InputListHasSuggestions.jsx